import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

const PRODUCT_QUALIFICATION_MODULE = 'PRODUCT_QUALIFICATION_MANAGEMENT'

const routes: RouteRecordRaw = {
  path: '/product-qualification',
  name: 'ProductQualification',
  redirect: '/product-qualification/management',
  component: Layout,
  meta: {
    title: '商品资质管理',
    icon: 'icon-product-qualification|svg',
    module: PRODUCT_QUALIFICATION_MODULE
  },
  children: [
    {
      path: 'management',
      name: 'ProductQualificationManagement',
      component: () => import('@/views/ProductQualificationManagement/index.vue'),
      meta: {
        title: '商品资质管理',
        showGuideIcon: true,
        module: PRODUCT_QUALIFICATION_MODULE
      }
    },
    {
      path: 'detail',
      name: 'ProductQualificationDetail',
      component: () => import('@/views/ProductQualificationDetail/index.vue'),
      meta: {
        title: '商品资质详情',
        module: PRODUCT_QUALIFICATION_MODULE,
        useModules: [PRODUCT_QUALIFICATION_MODULE],
        hidePageHeader: true,
        fullRedirectPath: true
      }
    }
  ]
}
export default routes
